// src/components/assistant/AssistantCard.js
import React from 'react';
import { Card, Badge, Button } from 'react-bootstrap';
import { format } from 'date-fns';

export default function AssistantCard({ assistant, onEdit, onDelete, onTest, t }) {
  const truncateText = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <Card style={{
      borderRadius: '12px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
      border: '1px solid #e0e0e0',
      transition: 'transform 0.2s',
      height: '100%'
    }}>
      <Card.Body>
        <div className="d-flex align-items-center mb-3">
          <span style={{ fontSize: '1.5rem', marginRight: '12px' }}>🤖</span>
          <div style={{ flex: 1 }}>
            <h5 className="mb-1" style={{ fontWeight: 600, fontSize: '1.1rem' }}>
              {assistant.name}
            </h5>
            <div>
              {assistant.is_default && (
                <Badge bg="primary" className="me-2" style={{ fontSize: '0.7rem' }}>
                  {t?.defaultBadge || 'Default'}
                </Badge>
              )}
              {assistant.is_active && (
                <Badge bg="success" style={{ fontSize: '0.7rem' }}>
                  {t?.activeBadge || 'Active'}
                </Badge>
              )}
            </div>
          </div>
        </div>

        <p style={{ color: '#666', fontSize: '0.9rem', minHeight: '60px' }}>
          {truncateText(assistant.description, 100)}
        </p>

        <div style={{ fontSize: '0.75rem', color: '#999', marginBottom: '16px' }}>
          <div>{t?.createdOn || 'Created'}: {format(new Date(assistant.created_at), 'MMM d, yyyy')}</div>
          <div>{t?.lastUpdated || 'Updated'}: {format(new Date(assistant.updated_at), 'MMM d, yyyy')}</div>
        </div>

        <div className="d-flex gap-2">
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => onEdit(assistant)}
            style={{ flex: 1, borderRadius: '8px', fontSize: '0.85rem' }}
          >
            ✏️ {t?.edit || 'Edit'}
          </Button>
          <Button
            size="sm"
            variant="outline-success"
            onClick={() => onTest(assistant)}
            style={{ flex: 1, borderRadius: '8px', fontSize: '0.85rem' }}
          >
            🧪 {t?.test || 'Test'}
          </Button>
          {!assistant.is_default && (
            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => onDelete(assistant)}
              style={{ borderRadius: '8px', fontSize: '0.85rem' }}
            >
              🗑️
            </Button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}
